export const CONFIRMATION_FORM_FIELDS = {
  SMS_CODE: 'smsCode',
} as const;

export const CONFIRMATION_FORM_FIELDS_LABELS_CONFIG = {
  [CONFIRMATION_FORM_FIELDS.SMS_CODE]: 'Код',
} as const;

export const MAX_RETRY_TIME_IN_SECONDS = 10 * 60;
